<template>
  <div class="content-margin">
    <NavBar :transparent-on-top="true"></NavBar>
    <vs-row justify="center">
      <vs-col w="9" xs="12" style="background-color: #313131; border-radius: 10px 10px; padding: 20px; min-height: 400px">
        <div style="text-align: center;"><h2>Mis lista por ver</h2></div>

        <!-- Selector -->
        <vs-button-group>
          <vs-button style="min-width: 200px" size="xl" flat icon :active="activeList === 'watch'" @click="activeList = 'watch'">
            <i class="bx bx-tv" style="margin-right: 10px"></i> TV
          </vs-button>
          <vs-button style="min-width: 200px" size="xl" flat icon :active="activeList === 'read'" @click="activeList = 'read'">
            <i class="bx bxs-book" style="margin-right: 10px"></i> Lectura
          </vs-button>
        </vs-button-group>

        <p v-if="!isLoggedIn">¡Lo sentimos! Para usar esta opción debes estar autenticado.</p>

        <div v-if="isLoggedIn">
          <div v-if="activeList === 'watch'">
            <div v-for="likedSerie in likedSeries" :key="likedSerie.idSerie" class="liked" style="margin-top: 20px;">
              <vs-card type="3" style="width: 100%;">
                <template #title>
                  <h3>{{ likedSerie.nombre }}<span class="badge tip middle">{{ likedSerie.type }}</span></h3>
                </template>
                <template #img>
                  <div class="ratio ratio-16x9"> <img :src="likedSerie.poster_horizontal" :alt="'Poster horizontal de ' + likedSerie.nombre"> </div>
                </template>
                <template #text><p>{{ likedSerie.descripcion }}</p></template>
                <template #interactions>
                  <vs-button>
                    Añadido el {{ $luxonDateTime.fromISO(likedSerie.timestamp).toLocaleString($luxonDateTime.DATE_SHORT) }}
                  </vs-button>
                  <vs-button warn icon>
                    <i class='bx bxs-bookmark-plus'></i>
                  </vs-button>
                  <!-- <vs-button class="btn-chat" shadow primary> <i class='bx bx-chat'></i> <span class="span"> 54 </span> </vs-button> -->
                </template>
              </vs-card>
            </div>
          </div>
          <div v-if="activeList === 'read'">
            <div v-for="likedBook in likedBooks" :key="likedBook.idLibro" class="liked" style="margin-top: 20px;">
              <vs-card type="3" style="width: 100%;">
                <template #title>
                  <h3>{{ likedBook.nombre }}</h3>
                </template>
                <template #img>
                  <img :src="likedBook.poster_horizontal" alt="">
                </template>
                <template #text>
                  <p>
                    {{ likedBook.descripcion }}
                  </p>
                </template>
              </vs-card>
            </div>
          </div>
        </div>

      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import NavBar from "../components/NavBar";
import axios from "axios";
export default {
  name: "MyWatchlist",
  components: {NavBar},
  data() {
    return {
      account: {},
      isLoggedIn: false,
      likedSeries: [],
      likedBooks: [],
      finishedLoading: false,
      activeList: 'watch'
    }
  },
  async beforeMount() {
    this.isLoggedIn = this.$store.state.auth.isLoggedIn;

    if (this.isLoggedIn === true) {
      this.account.token = this.$store.state.auth.token;
      this.account.username = this.$store.state.auth.username;
    }
  },
  async created() {
    if (this.$store.state.auth.isLoggedIn) {
      await axios
          .post(`https://api.videnti.co/user/watchlist/retrieve`,
              new URLSearchParams(),
              { headers: { "Content-Type": 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + this.$store.state.auth.token, } }
          ).then(res => {
            this.likedSeries = res.data;
            if (res.data.error) { this.checkIfJWTExpired(res.data.message); }
          });
      await axios
          .post(`https://api.videnti.co/user/watchlist/retrieve?type=read`,
              new URLSearchParams(),
              { headers: { "Content-Type": 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + this.$store.state.auth.token, } }
          ).then(res => {
            this.likedBooks = res.data;
            if (res.data.error) { this.checkIfJWTExpired(res.data.message); }
          });
      this.finishedLoading = true
    } else {
      this.finishedLoading = true
    }
  },
  methods: {
    openLogin() {
      NavBar.data().popup.login.active = true;
    }
  }
}
</script>

<style scoped>
.content-margin {
  margin-top: 134px;
}
</style>
